"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    shopUser: 'Användare' || 'shopUser',
    registerWithNewCustomerSubUnit: 'Registrera användare' || 'registerWithNewCustomerSubUnit',
    registerWithExistingCustomerSubUnit: 'Registrera användare' || 'registerWithExistingCustomerSubUnit',
    registerWithNewSupplierCustomer: 'Registrera kundanvändare' || 'registerWithNewSupplierCustomer',
    registerWithExistingSupplierCustomer: 'Registrera kundanvändare' || 'registerWithExistingSupplierCustomer',
    registerThroughInvite: 'Registrera användare med inbjudan' || 'registerThroughInvite',
    login: 'Logga in' || 'login',
    changeActiveMembership: '' || 'changeActiveMembership',
    me: '' || 'me',
    restaurantReport: '' || 'restaurantReport',
    changePassword: '' || 'changePassword',
    sendForgotPasswordLink: 'Skicka glömt lösenords länk' || 'sendForgotPasswordLink',
    restorePassword: '' || 'restorePassword',
    validatePasswordToken: '' || 'validatePasswordToken',
    updateMe: 'Redigera dig själv' || 'updateMe',
    writeShopUser: 'Uppdatera användare' || 'writeShopUser',
    approve: 'Godkänn användare' || 'approve',
    disapprove: 'Underkänn användare' || 'disapprove',
    verifyEmail: 'Aktivera' || 'verifyEmail',
    activate: 'Aktivera' || 'activate',
    deactivate: 'Spärra konto' || 'deactivate',
    changeCustomer: 'Byt kund inlogget är kopplat till' || 'changeCustomer',
    getCustomerForSessionUser: 'Hämta kundinfo' || 'getCustomerForSessionUser',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    firstName: 'Förnamn' || 'firstName',
    lastName: 'Efternamn' || 'lastName',
    phone: 'Telefon' || 'phone',
    email: 'Epost' || 'email',
    password: 'Lösenord' || 'password',
    customerSubUnitId: 'Centralt Kund-Id' || 'customerSubUnitId',
    preferredCustomerSubUnitId: 'Föredragen Kundenhets-Id' || 'preferredCustomerSubUnitId',
    supplierCustomerId: 'Leverantörs Kund-Id' || 'supplierCustomerId',
    shopConfigId: 'Shop id' || 'shopConfigId',
    forgotPasswordToken: 'Glömt Lösen Token' || 'forgotPasswordToken',
    owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
    emailVerificationToken: 'Epost verifikations token' || 'emailVerificationToken',
    hasVerifiedEmail: 'Verifierad epost' || 'hasVerifiedEmail',
    approved: 'Godkänd' || 'approved',
    active: 'Aktiv' || 'active',
    deactivationComment: 'Inaktiveringskommentar' || 'deactivationComment',
};
